import { SvgIconProps } from '@mui/material';

interface WelcomeVoucherCircleProps extends SvgIconProps {
  imgUrl?: string;
  width?: string;
  height?: string;
}

const WelcomeVoucherCircle = ({
  height = '106',
  width = '116',
  imgUrl = '',
  className,
}: WelcomeVoucherCircleProps) => (
  <svg width={width} height={height} viewBox="0 0 116 116" fill="none" className={className}>
    <defs>
      <clipPath id="circleView">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.3047 81.8718C-1.17625 66.4623 -3.01043 46.0497 5.25641 29.2202C7.48819 24.6761 10.9128 20.835 14.4178 17.1808C18.6306 12.7859 23.0989 8.51404 28.4357 5.58645C40.5626 -1.06867 61.0676 0.60458 74.0583 3.24107C138.726 16.3738 125.236 129.712 56.7508 113.491C44.7446 110.646 33.8696 104.334 23.5154 97.6245C17.2886 93.5869 12.1624 88.1436 8.3047 81.8718Z"
          fill="red"
        />
      </clipPath>
    </defs>
    <image height="100%" href={imgUrl} clipPath="url(#circleView)" aria-label="Perk Image" />
  </svg>
);

export default WelcomeVoucherCircle;
